import { Warning } from '@mui/icons-material';
import { Grid, Typography } from '@mui/material';
import React, { useCallback, useEffect } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import {
  ProcessStep,
  ProcessStepSubCategories,
} from '../../common/enums/enums';
import { GenConfirmationDialog } from '../GenDialogs';

const RestoreModal = ({
  open,
  vendorOrderId,
  handleOpenState,
  statusChange,
  setCurrentLoadingButton,
  isApiLoading,
  woNumber,
}) => {
  const { t } = useTranslation('workOrderStepper');

  const handleCloseClick = useCallback(() => {
    handleOpenState(false);
    setCurrentLoadingButton(null);
  }, [handleOpenState, setCurrentLoadingButton]);

  const handleOnConfirm = () => {
    statusChange(
      ProcessStep.IN_PROCESS,
      vendorOrderId,
      ProcessStepSubCategories.RESTORED
    );
  };

  useEffect(() => {
    if (!isApiLoading) {
      handleCloseClick();
    }
  }, [isApiLoading, handleCloseClick]);

  return (
    <GenConfirmationDialog
      open={open}
      title={t('wOStepperRestorePopUp.title')}
      titleIcon={Warning}
      titleIconColor="warning"
      closeText={t('wOStepperRestorePopUp.close')}
      onClose={handleCloseClick}
      onRefuse={handleCloseClick}
      confirmText={t('wOStepperRestorePopUp.confirm')}
      onConfirm={handleOnConfirm}
      isLoading={isApiLoading}
      children={
        <Grid container direction="column" alignItems="center">
          <Grid item width="100%">
            <Typography
              variant="body1"
              color="textSecondary"
              textAlign="center"
              mb={3}
            >
              <Trans
                t={t}
                i18nKey="wOStepperRestorePopUp.subtitle"
                values={{ woNumber }}
              />
            </Typography>
          </Grid>
        </Grid>
      }
    />
  );
};

export default RestoreModal;
